var map = {
	"./add-existing-registry-banner.gif": 1302,
	"./addexistingregistry_379x180_v2.jpg": 551,
	"./addexistingregistry_548x260.jpg": 1303,
	"./computer.png": 413,
	"./computer@2x.png": 1304,
	"./event.png": 169,
	"./event@2x.png": 1305,
	"./faq.png": 1306,
	"./faq@2x.png": 1307,
	"./home.png": 1308,
	"./home@2x.png": 1309,
	"./photo.png": 1310,
	"./photo@2x.png": 1311,
	"./poi.png": 1312,
	"./poi@2x.png": 1313,
	"./registry-video.jpg": 1314,
	"./registry-video@2x.jpg": 1315,
	"./registry.png": 1316,
	"./registry@2x.png": 1317,
	"./registryconversion_zolaintegration.jpg": 1318,
	"./registryconversion_zolaintegration@2x.jpg": 1319,
	"./rsvp.png": 1320,
	"./rsvp@2x.png": 1321,
	"./travel.png": 1322,
	"./travel@2x.png": 1323,
	"./wedding_party.png": 1324,
	"./wedding_party@2x.png": 1325
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1301;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages nonrecursive \.(jpg|jpeg|png|gif|svg)(\?.*)?$
// module id = 1301
// module chunks = 40